module.exports = __webpack_public_path__ + "media/img/corporate/career-mag-showcase-2f61e47bf3859fc79223b459cbb49363.png";